import React, { useState, useEffect, useContext } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";

import index from "@beeldit/core/services";
import { Room } from "../models/Room";
import { ConfigurationsContext } from "@main/contexts/ConfigurationsContext";

interface Option {
  label: string;
  value: number | string;
}

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange, formContext } =
    props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [options, setOptions] = useState<Option[]>([]);

  const errorHandler = useErrorHandler();
  const { rooms, setRooms } = useContext(ConfigurationsContext);

  useEffect(() => {
    // Verificar si ya hay valores en "rooms"
    if (rooms && rooms.length > 0) {
      initializeOptions(rooms); // Usar los valores existentes
    } else {
      // Hacer la petición si no hay valores en "rooms"
      index("rooms")
        .then((response: any) => {
          setRooms(response.data.elements); // Guardar en el contexto global
          initializeOptions(response.data.elements); // Inicializar opciones locales
        })
        .catch((error: any) => {
          errorHandler(error, null);
        });
    }
  }, []);

  const initializeOptions = (rooms: Room[]) => {
    const options = rooms.map((room: Room) => {
      const label = room.name + " ";
      return { label: label, value: room.id };
    });
    setOptions(options);

    // Seleccionar la opción actual si existe
    const currentSelectedOption = options.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  };

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  return (
    <Select
      id={id}
      options={options}
      value={selectedOption}
      required={required}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder="Selecciona una habitación"
      isClearable={true}
    />
  );
}

function RoomSelector(props: any) {
  const {
    id,
    options,
    value,
    required,
    disabled,
    readonly,
    onChange,
    formContext,
  } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options.enumOptions}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
      formContext={formContext}
    />
  );
}

export default RoomSelector;
